import React, { PureComponent } from 'react';
require('!style!css!less!../../css/sparkline.less'); // eslint-disable-line

function generatePointsFromData(width, height, data) {
  let maxValue = 0;
  data.forEach((d) => {
    if (d > maxValue) maxValue = d;
  });

  const xIncrement = data.length > 1 ? width / (data.length - 1) : 0;

  const points = data.map((d, i) => {
    const x = i * xIncrement;
    const dWeight = maxValue ? d / maxValue : 0;
    const y = height - (height * dWeight);
    return `${x} ${y}`;
  });

  return points.join(' ');
}

export default class Sparkline extends PureComponent {
  render() {
    const width = 90;
    const height = 20;

    const splitData = this.props.values.split(',').map(x => parseInt(x, 10));
    splitData.reverse();
    const dataPoints = generatePointsFromData(width, height, splitData);

    return (
      <div className="atlaskit-registry-sparkline">
        <svg height={height} width={width}>
          <polyline
            points={`${dataPoints} ${width} ${height} 0 ${height}`}
            className="spark-fill"
          />
          <polyline
            points={dataPoints}
            className="spark-outline"
          />
          <polyline
            points={generatePointsFromData(width, height, [0, 0, 0])}
            className="spark-bottom-line"
          />
          Sorry, your browser does not support inline SVG.
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MetricsPage/Sparkline.jsx